import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const apolloConfig: TSPConfig = {
  key: 'apollo',
  name: 'Apollo',
  category: TSPCategory.API_KEY,
  helpText: (
    <ol>
      <li>In the manage view, click the Details icon (person with a gear)</li>
      <li>Under "API Key", copy the code.</li>
      <li>
        If there is no code, click "Generate" and then copy the generated code.
      </li>
      <li>Input that code here.</li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default apolloConfig;
